// Qué ve cada tier. Port de assetto-gallery/app/src/licensing/features.ts.
//
// ESTE ES EL ÚNICO ARCHIVO QUE SE EDITA para mover una feature entre free y
// pago. No hay que tocar componentes ni endpoints: la UI pregunta por el nombre
// de la feature, no por el tier.
//
// Es isomórfico a propósito — corre igual en el server (requireFeature) y en el
// cliente (hasFeature) porque es una función pura sobre constantes, sin DB.
//
// Dos reglas que no se negocian:
//
//  1. Una feature paga no puede dejar datos que la app no sepa leer con la
//     feature apagada. Si se cae el pledge, las configs del usuario tienen que
//     seguir abriendo.
//  2. Esconder la UI no es seguridad. Todo endpoint propio de una feature paga
//     llama a requireFeature() aparte del gate visual.

/** @typedef {'free' | 'pro'} Tier */

export const TIERS = /** @type {const} */ (['free', 'pro'])

// Rango para resolver el tier efectivo cuando hay varios grants vivos.
export const TIER_RANK = { free: 0, pro: 1 }

const TODOS = ['free', 'pro']
const SOLO_PRO = ['pro']
const SOLO_FREE = ['free']

// `audience` = qué tiers ven la feature.
//   TODOS     → cualquiera (es el destino de una feature que se libera)
//   SOLO_PRO  → detrás del muro
//   SOLO_FREE → al revés (hoy solo la publicidad: el que paga no la ve)
export const FEATURES = {
    // Los 7 módulos del editor que hoy están detrás del candado. Un solo
    // permiso para los 7: hoy se desbloquean juntos y no tiene sentido
    // multiplicar llaves que siempre se giran a la vez.
    modulos_avanzados: {
        label: 'Módulos avanzados del editor',
        audience: SOLO_PRO,
        note: 'Graphics, Video, Practice, Custom Scripts, Special Binds, Custom Binds y Radio.',
    },
    // Crear, renombrar, duplicar, bloquear y eliminar configs, más la selección
    // múltiple. El usuario free sigue pudiendo usar y editar la config que tiene.
    gestion_configs: {
        label: 'Gestión de configs (Manager)',
        audience: SOLO_PRO,
        note: 'Crear, renombrar, duplicar, bloquear y eliminar. Editar la config activa es libre.',
    },
    // Banner de upsell y (a futuro) los slots de publicidad.
    publicidad: {
        label: 'Publicidad',
        audience: SOLO_FREE,
        note: 'El que apoya el proyecto no ve promos.',
    },
}

export const FEATURE_KEYS = Object.keys(FEATURES)

/** @param {Tier} tier @param {string} key */
export function isFeatureOn(tier, key) {
    const def = FEATURES[key]
    if (!def) return false
    return def.audience.includes(tier)
}

/** Lista de features habilitadas para un tier. Es lo que viaja al cliente. */
export function featuresFor(tier) {
    return FEATURE_KEYS.filter((key) => isFeatureOn(tier, key))
}
